<template>
  <div class="app-wrap">
    <div v-if="isLoading" class="se-pre-con"></div>
    <img alt="Gomobile logo" src="@/assets/logo.svg" class="company-logo" />
    <form v-if="!showThanks" action="#">
      <div class="paragraph-wrap">
        <h1 class="text-bold text-primary no-top-margin">
          {{ $t("main.header") }}
        </h1>
        <p class="paragraph">{{ $t("main.text1") }} {{ $t("main.text2") }}</p>
        <h2 class="text-bold text-primary">{{ $t("name.header") }}</h2>
        <TextareaAutosize
          :class="[
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea',
            isMissing('name.comment') && 'must-answer',
          ]"
          v-model="form.name.comment"
          type="text"
          :min-height="10"
          :max-height="350"
          :placeholder="$t('name.placeholder')"
        />
        <div
          v-for="section in ratingSections"
          :key="section.code"
          class="paragraph-wrap"
        >
          <h2 class="text-bold" v-if="section.showHeader">
            Отметьте по шкале от 1 до 5 необходимость в услугах ниже: <br />
            {{ section.title }}
          </h2>

          <!-- шкалы 1-5 -->
          <div
            v-for="q in section.questions"
            :key="q.code"
            :class="isMissing(`${section.code}.${q.code}`) && 'must-answer'"
          >
            <h3 class="text-bold title-faq">{{ q.label }}</h3>
            <ThePointsbar
              :size="5"
              :code="q.code"
              :full-name="true"
              :alert-line="isMissing(`${section.code}.${q.code}`)"
              @change="saveRating(section.code, q.code, $event)"
            />
          </div>
          <!-- блок с Radio -->
          <div
            v-if="section.radio"
            :class="
              isMissing(`${section.code}.${section.radio.code}`) &&
              'must-answer'
            "
          >
            <h3 class="text-bold title-faq">
              {{ section.radio.label }}
            </h3>
            <TheRadiobox
              v-for="opt in radioOptions"
              :key="opt"
              :text="opt"
              :name="section.radio.code"
              :checked="form[section.code][section.radio.code] === opt"
              @radioChange="
                saveRadio(section.code, section.radio.code, $event.text)
              "
            />
          </div>

          <!-- комментарии -->
          <template v-if="section.comment">
            <h3 class="text-bold title-faq">
              {{ section.comment.label }}
            </h3>
            <TextareaAutosize
              :class="
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea'
              "
              v-model="form[section.code][section.comment.code]"
              :min-height="10"
              :max-height="350"
              :placeholder="$t('fullRating.comment')"
            />
          </template>
        </div>

        <!-- СВОБОДНЫЕ КОММЕНТАРИИ -->
        <div class="paragraph-wrap">
          <h2 class="text-bold">
            Прокомментируйте, пожалуйста, чем мы еще можем быть вам полезны?
          </h2>

          <div v-for="c in freeComments" :key="c.code">
            <h3 class="text-bold title-faq">{{ c.label }}</h3>
            <TextareaAutosize
              :class="
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea'
              "
              v-model="form.additionalNeeds[c.code]"
              :min-height="10"
              :max-height="350"
              :placeholder="$t('fullRating.comment')"
            />
          </div>
        </div>
      </div>

      <button type="button" class="submit-button" @click="sendFeedback">
        <span>{{ $t("sendBtn") }}</span
        ><img src="@/assets/message.svg" />
      </button>
    </form>
    <div v-else class="thanks-text">
      <h1>{{ $t("thanks.header") }}</h1>
      <p>
        {{ $t("thanks.text2") }} (<a
          class="enable-select"
          :href="`mailto: ${$t('thanks.email1')}`"
          >{{ $t("thanks.email1") }}</a
        >) {{ $t("thanks.text3") }} (<a
          class="enable-select"
          :href="`mailto: ${$t('thanks.email2')}`"
          >{{ $t("thanks.email2") }}</a
        >).
      </p>
    </div>
  </div>
</template>

<script>
import ThePointsbar from "@/components/ThePointsbar";
import TheRadiobox from "@/components/TheRadiobox";
import TextareaAutosize from "@/components/TextareaAutosize.vue";
import API from "@/api";

export default {
  name: "App",
  components: {
    TheRadiobox,
    ThePointsbar,
    TextareaAutosize,
  },
  data: function () {
    return {
      missingFields: [],
      requiredFields: [
        "name.comment",
        "techSupport.setupCampaigns",
        "techSupport.fraudAudit",
        "techSupport.multiAudit",
        "techSupport.extraSupportCost",
        "paidServices.sensorReports",
        "paidServices.creativeHelp",
        "paidServices.competitorAnalysis",
        "paidServices.asoHelp",
      ],
      otherHowFound: "",
      showThanks: false,
      isLoading: false,
      isAlert: false,
      feedbackData: {
        table: "simple",
        version: "v2",
        name: "",
        isShort: false,
        fullRating: "",
        kpiRating: "",
        personalFeedback: "",
        commandRating: "",
        howFound: [],
        feedback: "",
        paramName: "",
      },
      form: {
        name: {
          comment: "",
        },
        techSupport: {
          setupCampaigns: null,
          fraudAudit: null,
          multiAudit: null,
          extraSupportCost: null,
          comment: "",
        },
        paidServices: {
          sensorReports: null,
          creativeHelp: null,
          competitorAnalysis: null,
          asoHelp: null,
          comment: "",
        },
        additionalNeeds: {
          auditsAndWorkshops: "",
          sourcesSplit: "",
          other: "",
        },
      },
      ratingSections: [
        {
          code: "techSupport",
          title: "Дополнительная техническая поддержка",
          showHeader: true,
          questions: [
            {
              code: "setupCampaigns",
              label:
                "Предоставление рекомендаций по настройке рекламных кампаний от экспертов агентства на этапе старта",
            },
            { code: "fraudAudit", label: "Проведение аудитов по фроду" },
            {
              code: "multiAudit",
              label:
                "Проведение аудитов рекламных кампаний по нескольким источникам и предоставление рекомендаций ",
            },
          ],
          radio: {
            code: "extraSupportCost",
            label:
              "Готовы ли на оказание дополнительной обширной тех. поддержки за доп. кост",
          },
          comment: {
            code: "comment",
            label: "Любые комментарии по дополнительной технической поддержке",
          },
        },
        {
          code: "paidServices",
          title: "Предоставление дополнительных услуг (на платной основе)",
          showHeader: true,
          questions: [
            {
              code: "sensorReports",
              label:
                "Есть ли необходимость в предоставлении выгрузок/аналитических справок из инструментов, нап. Sensor tower",
            },
            {
              code: "creativeHelp",
              label: "Есть ли необходимость в помощи с креативными материалами",
            },
            {
              code: "competitorAnalysis",
              label: "Есть необходимость в проведении анализа конкурентов",
            },
            { code: "asoHelp", label: "Есть ли необходимость с помощью в АSO" },
          ],
          comment: {
            code: "comment",
            label: "Любые комментарии по дополнительным услугам",
          },
        },
      ],

      freeComments: [
        {
          code: "auditsAndWorkshops",
          label:
            "Аудиты, воркшопы, регулярное предоставление дайджестов по новым инструментам/возможностям площадок и пр.",
        },
        {
          code: "sourcesSplit",
          label:
            "Как вы разделяете какие источники закрываете ин-хаус, а какие отдаете агентству? Возможно будем полезны вам в закупке других источников",
        },
        { code: "other", label: "Любые другие потребности/комментарии" },
      ],
    };
  },

  methods: {
    isEmpty(val) {
      return val === null || val === undefined || val === "";
    },
    validateForm() {
      this.missingFields = this.requiredFields.filter((path) => {
        return this.isEmpty(
          path.split(".").reduce((o, k) => (o ? o[k] : undefined), this.form)
        );
      });
      return this.missingFields.length === 0;
    },
    isMissing(path) {
      return this.missingFields.includes(path);
    },
    async sendFeedback() {
      if (!this.validateForm()) {
        this.$nextTick(() => {
          const first = this.$el.querySelector(".must-answer");
          if (first) {
            first.scrollIntoView({ block: "center", behavior: "smooth" });
          }
        });
        return;
      }
      const payload = {
        table: "feedback_service_resell",
        version: "v1",
        paramName: this.feedbackData.paramName || "",
        answers: this.form,
      };

      this.isLoading = true;
      try {
        const api = new API();
        await api.push(payload);
        this.showThanks = true;
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }

      //   if (
      //     this.feedbackData.fullRating.length > 0 &&
      //     this.otherHowFound.length > 0
      //   ) {
      //     this.feedbackData.fullRating =
      //       this.feedbackData.fullRating + " Коментарий: " + this.otherHowFound;
      //   }
      //   if (this.feedbackData.recommendation.length === 0) {
      //     document
      //       .getElementById("must-answer")
      //       .scrollIntoView({ block: "center", behavior: "smooth" });
      //     this.isAlert = true;
      //     return;
      //   }

      //   this.isLoading = true;
      //   const that = this;
      //   try {
      //     if (this.feedbackData.paramName === "") {
      //       this.feedbackData.paramName =
      //         "Клиент стер уникальный параметр ссылки";
      //     }
      //     const api = new API();
      //     await api.push(this.feedbackData).then(function () {
      //       that.isLoading = false;
      //     });
      //     that.isLoading = false;
      //   } catch (e) {
      //     console.error(e);
      //   }
      //   this.showThanks = true;
      //   console.log(this.feedbackData);
    },
    getData: async function () {
      try {
        const requestOptions = {
          method: "GET",
          redirect: "follow",
        };

        fetch(
          "https://script.google.com/macros/s/AKfycbz6nXZwOixTOAYU8AZ2nx-_fuF3ABLGM1AaoUx5yUdFdcE_FS_l1aavuEViiK0xDs_yEg/exec",
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            const locat = location;
            let index = 0;
            let end = 0;
            for (let i = 0; i < result.length; i++) {
              if ("ServicesResell" === result[i][0]) {
                index = i;
              }
              if ("GoMobileWW" === result[i][0]) {
                end = i;
              }
            }
            result = result.slice(index + 1, end);
            for (let i = 0; i < result.length; i++) {
              let param = result[i][1].slice(result[i][1].indexOf("?"));
              if (param == locat.search) {
                console.log("321", result[i][0]);
                this.feedbackData.paramName = result[i][0];
                console.log(this.feedbackData.paramName);
                return;
              }
            }
          })
          .catch((error) => console.error(error));
      } catch (err) {
        console.log(err);
      }
    },
    addHowFound(val) {
      this.feedbackData.fullRating = val.text;
    },
    saveRating(section, question, value) {
      this.form[section][question] = value;
    },
    saveRadio(section, field, option) {
      this.form[section][field] = option;
    },
  },
  computed: {
    screenWidth() {
      return window.innerWidth;
    },
    radioOptions() {
      return this.$t("dopcost.grades", { returnObjects: true });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
